import React from "react";

import { usePopoverContext } from "@components/organisms/popover/usePopoverContext";
import { MenuItem } from "@/components/atoms/menuItem";

export const PopoverMenuItem = React.forwardRef<
  HTMLHeadingElement,
  React.HTMLProps<HTMLHeadingElement>
>(function PopoverMenuItem(props, ref) {
  const { setOpen } = usePopoverContext();

  return (
    <MenuItem
      {...props}
      ref={ref}
      onClick={(event) => {
        props.onClick?.(event);
        setOpen(false);
      }}
    >
      {props.children}
    </MenuItem>
  );
});
